import { AppointmentStatus } from '../../models/appointment/Appointment'

const UNCLOSED_SESSION_APPOINTMENT_STATUSES: AppointmentStatus[] = ['newAppt', 'rescheduled', 'concluded']

/**
 * Whether an appointment's status means the session was never closed, so it still owes an invoice.
 *
 * `concluded` counts: it is written when an on-platform video session ends, before the session is
 * closed.
 */
export const isUnclosedSessionStatus = (appointmentStatus: string | undefined): boolean =>
  UNCLOSED_SESSION_APPOINTMENT_STATUSES.includes(appointmentStatus as AppointmentStatus)

export enum CANCELATION_OPTIONS {
  'needMoreTime' = 'needMoreTime',
  'lookingOtherCareOptions' = 'lookingOtherCareOptions',
  'readyToGraduate' = 'readyToGraduate',
  'emergency' = 'emergency',
  'notFeelingWell' = 'notFeelingWell',
  'schedulingConflict' = 'schedulingConflict',
  'other' = 'other',
}

export const INITIAL_DAYS_OF_AVAILABILITY_SHOWN = 7
